<!--
  PlanIcon -- a plan's card icon in its accent color.

  The ONE renderer for a plan icon (/pricing cards, the SA plan card header
  and its live preview), so a plan looks the same everywhere. Icon and color
  come from the plan's STORED keys via resolvePlanPresentation(plan); nothing
  here knows or accepts a position. A stale key draws the constant fallback.

  The root carries data-icon-key / data-accent-key (the RESOLVED keys) so a
  test or a ui-runner scenario can read what was drawn.
-->
<template>
    <span
        class="plan-icon"
        :style="{ color: presentation.accentHex }"
        :data-testid="testId || undefined"
        :data-icon-key="presentation.iconKey"
        :data-accent-key="presentation.accentKey"
        :title="presentation.iconLabel"
    >
        <v-icon :icon="presentation.icon" :size="size" aria-hidden="true" />
    </span>
</template>

<script>
import { resolvePlanPresentation } from "@/utils/planPresentation";

export default {
    name: "PlanIcon",
    props: {
        // Any object carrying icon_key / accent_key (a plan row).
        plan: { type: Object, default: null },
        size: { type: [Number, String], default: 24 },
        testId: { type: String, default: "" },
    },
    computed: {
        presentation() {
            return resolvePlanPresentation(this.plan);
        },
    },
};
</script>

<style scoped>
.plan-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
}
</style>
